import React, { Suspense, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import Text from 'components/Text';
import Tabs from 'components/Tabs';
import ShopItemTeaser, { ShopItemTeaserSkeleton } from 'components/ShopItemTeaser';
import Page from '../Page';
import Model from '../../../model';
import { IconButton } from 'components/Button';
import SortSelect from './SortSelect';
import Banner from './Banner';
import { times } from 'utils/render';

import './index.sass';
import { useNavigate, useParams } from 'react-router';
import Icon from 'components/Icon';
import { Link } from 'react-router-dom';
import { whatsAppContacts } from 'components/AddressAndPhones';

const { block, el } = bem('shop');

const title = 'Магазин';

const tabs = [
    { label: 'Все' },
    { label: 'Изделия' },
    { label: 'Курсы' },
]

const Shop = () => {

    const { tag = null } = useParams();
    const isKZ = Model.kz.isKZ;

    useEffect(() => {
        Model.shop.setTag(tag);
    }, [ tag ])

    const [ shopItems, setShopItems ] = useState([]);
    const [ sorting, setSorting ] = useState('popular');
    const { isMobile } = useMobile()
    const sliceNumber = isMobile ? 2 : 8;

    const { items, digitals, allItems } = Model.shop;

    useEffect(() => {
        if (digitals.length === 0 || items.length === 0) {
            Model.shop.stale = true;
        }
    }, [])

    const sort = (sorting) => {
        if (sorting === 'price-asc') {
            setShopItems(old => [ ...old ].sort((a, b) => a.data.price - b.data.price))
        } else if (sorting === 'price-desc') {
            setShopItems(old => [ ...old ].sort((a, b) => b.data.price - a.data.price))
        } else if (sorting === 'new') {
            setShopItems(old => [ ...old ].sort((a, b) => new Date(b.data.createdAt) - new Date(a.data.createdAt)))
        } else if (sorting === 'popular') {
            setShopItems(old => [ ...old ].sort((a, b) => b.data.points - a.data.points))
        }
    }

    useEffect(() => {
        sort(sorting);
    }, [ sorting ]);

    const handleChange = (newValue) => {
        if (newValue === 1) {
            setShopItems(items);
        }
        if (newValue === 2) {
            setShopItems(digitals);
        }
        if (newValue === 0) {
            setShopItems(allItems);
        }
        sort(sorting);
    };

    const Fallback = times((key) => <ShopItemTeaserSkeleton key={ key } />, 8)

    const { activeItemsData } = Model.shop;

    return (
        <Page className={ block() } title={ tag ? `#${ tag }` : title }>
            <div className={ el('need-help') }>
                <IconButton to={ whatsAppContacts.link } name={ 'caret-right' }>
                    <Text>{ `Как оплатить\nза пределами РФ?` }</Text>
                </IconButton>
            </div>
            <div className={ el('description') }>
                <Text>
                    Добро пожаловать в наш онлайн-магазин. Здесь вы можете купить сертификат на сессию с терапевтом,
                    чтобы подарить его тому, кто о нем сейчас мечтает, а также образовательные курсы и эксклюзивные
                    вещи, которые мы создали с большой любовью. Вы это почувствуете.
                </Text>
                { tag && <Link className={ el('go-to-shop') } to={ '/goods ' }>
                    <Icon name='arrow-left' />
                    <Text>В магазин</Text>
                </Link> }
            </div>
            { !tag && <div className={ el('tabs-block') }>
                { !isKZ && <div className={ el('tabs') }>
                    <Tabs onChange={ handleChange } tabs={ tabs } />
                </div> }
                <div className={ el('sort-select') }>
                    <SortSelect value={ sorting } onChange={ setSorting } />
                </div>
            </div> }
            <div className={ el('list') }>
                <Suspense fallback={ Fallback }>
                    <ShopItemsList sliceNumber={ sliceNumber } shopItems={ shopItems } setShopItems={ setShopItems }
                                   resource={ activeItemsData } />
                </Suspense>
            </div>
        </Page>
    )
}

const ShopItemsList = observer(({ sliceNumber, shopItems, setShopItems, resource }) => {
    const items = resource.read();
    useEffect(() => {
        if (items.length > 0) {
            setShopItems(items);
        }
    }, [ items ]);
    const firstBlock = shopItems.slice(0, sliceNumber);
    const restBlock = shopItems.slice(sliceNumber);
    return <>
        { firstBlock.map((item, index) => <ShopItemTeaser key={ index } item={ item } />) }
        {/*<Banner />*/}
        { restBlock.map((item, index) => <ShopItemTeaser key={ index } item={ item } />) }
    </>
});

export default observer(Shop);
